import crmImg from '../images/CRM.png';
import ragImg from '../images/RAG.png';
import adCraftImg from '../images/AdCraft.png';
import shopifyImg from '../images/Shopify.png';
import linkedinInsightsImg from '../images/linkedin_insights.png';
import deepfakeImg from '../images/deepfake_coverpic.jpg';

export const Bio = {
  name: "Karthik Sagar",
  fullName: "Karthik Sagar Nallagula",
  roles: ["AI Engineer", "Full Stack Developer", "GenAI Developer"],
  description:
    "I build and ship end-to-end GenAI products — from LLM/agent pipelines and RAG backends to full-stack SaaS frontends. Currently engineering autonomous AI systems at Deepsolv AI.",
  github: "https://github.com/karthiksagarN",
  resume:
    "https://drive.google.com/file/d/1B8jVLDiAvJrp5Jwy0mlImxRA7_aSnDIZ/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/karthik-sagar-nallagula/",
  leetcode: "https://www.leetcode.com/karthiksagarn",
  twitter: "https://twitter.com/nkarthiksagar1",
  email: "karthik.sagarn@gmail.com",
  location: "Hyderabad, India",
};

export const experiences = [
  {
    role: "AI Engineer Intern",
    company: "Deepsolv AI",
    date: "Jan 2026 — July 2026",
    points: [
      'Built "Adam," an autonomous AI ad script writer using Claude Agent SDK with multi-turn stateful conversations, 6 custom MCP tools, real-time SSE streaming, and a modular Jinja2 prompt system supporting 4 creative strategies.',
      "Designed the Angle Research Engine — a multi-phase pipeline collecting data from 6+ sources, running deterministic frequency/gap analysis, generating 3-tier LLM-friendly wikis, and orchestrating Claude Code sessions for structured competitive intelligence.",
      "Architected static ad creative generation using Gemini 2.5 Pro for competitor blueprint extraction and Gemini 2.5 Flash for image generation with configurable aspect ratios and multi-image context.",
      "Managed cloud orchestration with AWS Step Functions, ECS task execution for long-running Claude Code sessions (budget-aware, up to 90 min), and async callback-based job completion with S3 I/O.",
    ],
    tech: [
      "Claude Agent SDK",
      "MCP Tools",
      "AWS Step Functions",
      "ECS",
      "Gemini 2.5",
      "FastAPI",
      "SSE",
    ],
  },
];

export const skills = {
  "AI / ML": [
    "Machine Learning",
    "Deep Learning",
    "Generative AI",
    "Large Language Models",
    "RAG Pipelines",
    "Fine-Tuning",
    "Agentic AI",
    "NLP",
  ],
  "Frameworks": [
    "FastAPI",
    "PyTorch",
    "TensorFlow",
    "LangChain",
    "CrewAI",
    "Streamlit",
    "React",
  ],
  "Languages & DBs": [
    "Python",
    "Java",
    "JavaScript",
    "HTML / CSS",
    "MySQL",
    "MongoDB",
    "Vector DB",
  ],
  "Cloud & Tools": [
    "AWS",
    "Docker",
    "Git",
    "Linux",
    "Google Colab",
    "Jupyter",
    "HuggingFace",
  ],
};

export const projects = [
  {
    id: 1,
    title: "AdCraft AI Creative Studio",
    tagline: "AI-powered SaaS for generating studio-grade brand creatives",
    date: "Dec 2025",
    description:
      "Full-stack AI SaaS platform built with FastAPI, React, and Supabase that generates studio-grade brand creatives from raw product and logo images. Integrated NanoBananaPro for product-preserving image transformations and GPT-4o for automated taglines, headlines, and ad copy with 10+ visual style presets. Features secure authentication (Email+OTP & Google OAuth) and real-time creative generation.",
    image: adCraftImg,
    tags: ["React", "FastAPI", "Supabase", "GPT-4o"],
    category: "fullstack",
    github: "https://github.com/karthiksagarN/AdCraft-AI-Creative-Studio",
    live: "https://adcraftstudio.karthiknallagula.com/",
    featured: true,
  },
  {
    id: 2,
    title: "RAG Search Engine",
    tagline: "Knowledge-base search with multi-chat RAG pipeline",
    date: "Oct — Nov 2025",
    description:
      "Complete Retrieval-Augmented Generation pipeline using FastAPI and React. Integrates LangChain and OpenAI for contextually accurate querying of user-uploaded PDF/TXT documents. Multi-chat support with independent, persistent Chroma vector databases for robust data isolation across sessions.",
    image: ragImg,
    tags: ["FastAPI", "LangChain", "OpenAI", "Chroma", "React"],
    category: "fullstack",
    github: "https://github.com/karthiksagarN/RAG-SEARCH-ENGINE",
    live: "https://rag-engine.karthiknallagula.com/",
    featured: true,
  },
  {
    id: 3,
    title: "AI-Powered CRM Platform",
    tagline: "Full-stack CRM with AI segmentation & campaign automation",
    date: "Sep — Oct 2025",
    description:
      "Full-stack CRM system with Google OAuth, JWT security, and batch APIs managing 1000+ customer/order records. AI-powered natural language segmentation & campaign automation with 95%+ targeting accuracy. Analytics dashboards with AI-driven insights for real-time decision-making.",
    image: crmImg,
    tags: ["JavaScript", "MongoDB", "React", "Node.js", "AI"],
    category: "fullstack",
    github: "https://github.com/karthiksagarN/Mini-CRM-Platform-Frontend",
    live: "https://ai-crm.karthiknallagula.com/",
    featured: true,
  },
  {
    id: 4,
    title: "LinkedIn Insights Microservice",
    tagline: "Production-grade scraping, caching & AI analysis backend",
    date: "Dec 2025",
    description:
      "Backend microservice that scrapes LinkedIn company pages via Playwright, stores structured data in MongoDB, and uses Redis caching for fast responses. AI service generates analytical summaries. Includes Streamlit dashboard, Docker containerization, and Pytest testing.",
    image: linkedinInsightsImg,
    tags: ["FastAPI", "MongoDB", "Redis", "Docker", "OpenAI"],
    category: "fullstack",
    github: "https://github.com/karthiksagarN/Linkedin-Insights-Microservice",
    live: "https://linkedin-insights.streamlit.app/",
  },
  {
    id: 5,
    title: "Shopify Analytics Hub",
    tagline: "Multi-tenant Shopify store analytics platform",
    date: "Dec 2025",
    description:
      "End-to-end analytics platform connecting multiple Shopify stores with auto-sync via Shopify Admin API, secure auth with email verification, and a clean dashboard with actionable insights.",
    image: shopifyImg,
    tags: ["React", "Node.js", "MySQL", "Prisma", "Tailwind"],
    category: "fullstack",
    github: "https://github.com/karthiksagarN/Shopify-Store-Analytics",
    live: "https://shopify-hub.karthiknallagula.com/",
  },
  {
    id: 6,
    title: "DeepFake Detection",
    tagline: "CNN + LSTM video classification for deepfake detection",
    date: "Apr 2024",
    description:
      "CNN model using pre-trained ResNeXt50 with LSTM video classification. Trained on FF++ and Celeb-DF datasets achieving remarkable accuracies on both benchmarks.",
    image: deepfakeImg,
    tags: ["PyTorch", "OpenCV", "Deep Learning", "Computer Vision"],
    category: "ai",
    github: "https://github.com/karthiksagarN/DeepFake-Detection",
    live: "https://huggingface.co/spaces/karthiksagarn/DeepFake-Video-Detection",
  },
  {
    id: 7,
    title: "Dermi-AI",
    tagline: "AI-powered dermatological disease detection + chatbot",
    date: "Mar 2024",
    description:
      "CNN from scratch for detecting dermatological diseases plus a Medical AI ChatBot for detailed reports. Deployed on GCP Cloud Run, integrated with a Flutter app. Secured 7th at Great India HackFest 2k24.",
    tags: ["CNN", "LLM", "GCP", "Flutter"],
    category: "ai",
    github: "https://github.com/karthiksagarN/Dermi-AI-APP",
    live: "https://devfolio.co/projects/dermiai-a469",
  },
  {
    id: 8,
    title: "BART Fine-Tuned (406M params)",
    tagline: "Fine-tuned BART-large-cnn for text & dialogue summarization",
    date: "Mar 2024",
    description:
      "Fine-tuned Facebook's bart-large-cnn for text and conversational summarization using the SAMSum dataset. Achieved remarkable Rouge/BERT scores with loss of 0.1326. Published on HuggingFace.",
    tags: ["Transformers", "Fine-Tuning", "HuggingFace", "NLP"],
    category: "ai",
    github: "https://github.com/karthiksagarN/Bart-FineTuned-Model-406M",
    live: "https://huggingface.co/karthiksagarn/bart-samsum-finetuned",
  },
  {
    id: 9,
    title: "VcareIT — Emergency Response",
    tagline: "Medical AI assistant with speech accessibility — 1st place hackathon",
    date: "Feb 2024",
    description:
      "Emergency response app with Medical AI Consultant for immediate first-aid assistance. Implemented SpeechToText and TextToSpeech for visually impaired users. Won 1st place at Coder Hunt Hackathon, VIT-AP.",
    tags: ["LangChain", "OpenAI", "Streamlit", "Speech AI"],
    category: "ai",
    github: "https://github.com/karthiksagarN/VcareIT",
  },
];

export const education = [
  {
    school: "Vellore Institute of Technology, AP",
    degree: "B.Tech — CSE (AI & ML)",
    date: "2022 — 2026",
    grade: "CGPA: 8.47",
    desc: "Bachelor of Technology in Computer Science with specialization in Artificial Intelligence and Machine Learning.",
    logo: "https://imgs.search.brave.com/B6lcXRHqAalu1dvHiY-FOCw-Vt5t6HqUr8Gq_JdJbKQ/rs:fit:560:320:1/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvZW4vdGh1bWIv/YS9hNS9WSVQtQVBf/VW5pdmVyc2l0eV9z/ZWFsLnBuZy81MTJw/eC1WSVQtQVBfVW5p/dmVyc2l0eV9zZWFs/LnBuZw",
  },
  {
    school: "Delhi Public School, Hyderabad",
    degree: "CBSE XII — Higher Secondary",
    date: "2020 — 2022",
    desc: "Completed Class 12 with Science stream and Computer Science.",
    logo: "https://www.schoolsuniverse.com/_next/image?url=https%3A%2F%2Fcdn.schoolsuniverse.com%2Fmedia%2Fuploads%2F2024-10-15%252009%253A19%253A41.869256ddd.png&w=256&q=80&dpl=dpl_GrhNdmcUoc4fjhrTVrLKX4wiWzMM",
  },
  {
    school: "St. Joseph's Public School, Hyderabad",
    degree: "CBSE X — Primary & Secondary",
    date: "2010 — 2020",
    desc: "Completed Class 10 with Computer Applications.",
    logo: "https://www.sjpsmalakpet.org/img/St%20Joseph%20School%20Logo.png",
  },
];

export const certifications = [
  {
    title: "AWS Certified Cloud Practitioner",
    issuer: "Amazon Web Services",
    year: "2025",
  },
  {
    title: "Advanced Certification in Data Science & AI",
    issuer: "IIT Madras (via Intellipaat)",
    year: "2023",
  },
];
